import Image from "next/image";

import logoLight from "common/assets/ownspace-logo.svg";
import logoDark from "common/assets/ownspace.png";

interface Props {
  type: "light" | "dark",
  width: number,
}

export function Logo({ type, width }: Props) {
  return (
    <Image
      src={type === "dark" ? logoDark : logoLight}
      alt="ownspace-logo"
      width={width}
      style={{ zIndex: 8 }}
    />
  )
}
